import { createAction, createSlice } from "@reduxjs/toolkit";
import { Organization } from "../../@types/organization";
import { findOrganizations } from "./actions/findOrganizations";
interface OrganizationsState {
  organizations: Organization[];
  searchText: string;
}

const initialState = {
  organizations: [],
  searchText: "",
} as OrganizationsState;

export const setSearchText = createAction<string>("SET_SEARCH_TEXT");

const organizationsSlice = createSlice({
  name: "organizations",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(findOrganizations.fulfilled, (state, { payload }) => {
        state.organizations = payload;
      })
      .addCase(setSearchText, (state, { payload }) => {
        state.searchText = payload;
      });
  },
});

export default organizationsSlice.reducer;
